import { useCallback, useEffect, useRef } from "react";
function purgeStale(set) {
    set.forEach((el)=>{
        if (!document.contains(el)) set.delete(el);
    });
}
function useTabGroup() {
    const tabElements = useRef(new Set());
    const timeoutRef = useRef(null);
    useEffect(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    function registerTabElement(ref) {
        if (ref) tabElements.current.add(ref);
        else purgeStale(tabElements.current);
    }
    const focusNextElement = useCallback((triggerClick = false, fromElement)=>{
        if (!document) return;
        const focusOrClick = triggerClick ? 'click' : 'focus';
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (fromElement) {
            timeoutRef.current = setTimeout(()=>{
                purgeStale(tabElements.current);
                const liveList = Array.from(tabElements.current);
                const idx = liveList.indexOf(fromElement);
                if (-1 === idx || idx + 1 >= liveList.length) return;
                const currentFocus = document.activeElement;
                const currentIdx = liveList.indexOf(currentFocus);
                if (currentIdx > idx) return;
                liveList[idx + 1][focusOrClick]();
            }, 100);
            return;
        }
        const elementList = Array.from(tabElements.current);
        if (0 === elementList.length) return;
        const { activeElement } = document;
        if (activeElement && (activeElement instanceof HTMLInputElement || activeElement instanceof HTMLSelectElement || activeElement instanceof HTMLButtonElement)) {
            const selectedItemIndex = elementList.indexOf(activeElement);
            if (-1 === selectedItemIndex || selectedItemIndex + 1 >= elementList.length) {
                timeoutRef.current = setTimeout(()=>elementList[0][focusOrClick](), 0);
                return;
            }
            timeoutRef.current = setTimeout(()=>elementList[selectedItemIndex + 1][focusOrClick](), 0);
        }
    }, []);
    return {
        registerTabElement,
        focusNextElement
    };
}
export { useTabGroup };
